import React, { FC, useEffect, useState } from 'react';
import Select from '@domain-group/fe-co-select';
import { useStatus } from '../status-store';
import * as PortalApi from '../../lib/portal-api';

interface CredentialListProps {
  projectId: string;
  onChange: (selectedCredential: PortalApi.CredentialViewModel) => void;
}

interface SelectOption {
  label: string;
  value: string;
  data: PortalApi.CredentialViewModel;
}

const CredentialList: FC<CredentialListProps> = ({ projectId, onChange }) => {
  const status = useStatus();
  const [options, updateOptionList] = useState<SelectOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchOptionList = async () => {
      setIsLoading(true);
      if (projectId) {
        const projects = await PortalApi.getCredentials(
          status.accessToken,
          projectId,
        );
        updateOptionList(
          projects.map((credential) => ({
            label: `${credential.authClientId} (${
              credential.credentialType === 'oAuthClient'
                ? credential.flow
                : credential.credentialType
            })`,
            value: credential.id,
            data: credential,
          })),
        );
      }
      setIsLoading(false);
    };

    fetchOptionList();
  }, [projectId, status.accessToken]);

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <Select
      instanceId="swagger-credential-chooser"
      stretched
      label="Choose Credential"
      labelHidden={false}
      placeholder="Choose Credential"
      options={options}
      nowrap
      onChange={(selectedItem: SelectOption) => onChange(selectedItem.data)}
    />
  );
};

export default CredentialList;
